export default __webpack_public_path__ + "static/media/booty.79b8ebf3.png";